var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOptions,"circular":""}},_vm._l((_vm.originList),function(item,index){return _c('swiper-slide',{key:index},[(index - _vm.current < 3 && -2 < index - _vm.current)?_c('div',{staticClass:"swiper-zoom-container"},[_c('img',{attrs:{"src":item}})]):_vm._e()])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }